import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "line-icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 3 4 7v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-3-4zM4 7h16" }, null, -1),
    _createElementVNode("path", { d: "M16 11c0 2.2-1.8 4-4 4s-4-1.8-4-4" }, null, -1)
  ])))
}
export default { render: render }